module.exports = __webpack_public_path__ + "static/media/SWSCRC6-44.7a0778d7.mp3";